<template>
  <div class="cl-bars">
    <p v-if="!rows.length" class="cl-empty-line">{{ emptyLabel }}</p>

    <div
      v-for="row in visibleRows"
      :key="row.key || row.name"
      class="cl-bar-row"
      :class="{ 'is-clickable': clickable, 'is-active': clickable && row.key === activeKey }"
      :role="clickable ? 'button' : null"
      :tabindex="clickable ? 0 : null"
      @click="onPick(row)"
      @keydown.enter.prevent="onPick(row)"
      @keydown.space.prevent="onPick(row)"
    >
      <div class="cl-bar-head">
        <span class="cl-bar-name" :title="row.name">
          <i v-if="row.icon" :class="row.icon" aria-hidden="true"></i>
          {{ row.name }}
        </span>
        <span class="cl-bar-value">
          <strong>{{ format(row.amount) }}</strong>
          <small v-if="maxAmount">{{ share(row.amount) }}</small>
        </span>
      </div>
      <div class="cl-bar-track">
        <span class="cl-bar-fill" :style="fillStyle(row)"></span>
      </div>
      <div v-if="row.meta" class="cl-bar-meta">{{ row.meta }}</div>
    </div>

    <button
      v-if="rows.length > limit"
      class="btn-sm-outline cl-bar-toggle"
      type="button"
      @click="expanded = !expanded"
    >
      {{ expanded ? 'Show less' : `Show all ${rows.length}` }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'CombatLogBars',
  props: {
    rows: { type: Array, default: () => [] },
    limit: { type: Number, default: 10 },
    color: { type: String, default: 'var(--primary)' },
    emptyLabel: { type: String, default: 'No data' },
    formatter: { type: Function, default: null },
    clickable: { type: Boolean, default: false },
    activeKey: { type: String, default: '' },
  },
  emits: ['select'],
  data() {
    return { expanded: false }
  },
  computed: {
    visibleRows() {
      return this.expanded ? this.rows : this.rows.slice(0, this.limit)
    },
    maxAmount() {
      return this.rows.reduce((max, row) => Math.max(max, row.amount || 0), 0)
    },
    totalAmount() {
      return this.rows.reduce((sum, row) => sum + (row.amount || 0), 0)
    },
  },
  methods: {
    onPick(row) {
      if (!this.clickable) return
      this.$emit('select', row.key)
    },
    format(value) {
      if (this.formatter) return this.formatter(value)
      return new Intl.NumberFormat('ru-RU').format(Math.round(value || 0))
    },
    share(value) {
      if (!this.totalAmount) return ''
      return `${((value / this.totalAmount) * 100).toFixed(1)}%`
    },
    fillStyle(row) {
      const width = this.maxAmount ? Math.max(1, ((row.amount || 0) / this.maxAmount) * 100) : 0
      return {
        width: `${width}%`,
        background: row.color || this.color,
      }
    },
  },
}
</script>
